/**
 * The Menu Component renders the navigation element where you can
 * toggle between products, features and tiles
 */

import React, { PropTypes, Component } from 'react';

import { toggleTab, toggleMenu } from '../../modules/App/AppState';
import Accordion from '../../../../core_components/Accordion';
import MenuTabItem from './MenuTabItem';

import './menu.scss';

class Menu extends Component {

  constructor() {
    super();

    this.state = {
      accordionOpenIndex: 0,
    };

    this.onMenuToggle = this.onMenuToggle.bind(this);
    this.onTabClick = this.onTabClick.bind(this);
    this.isChecked = this.isChecked.bind(this);
  }

  componentWillReceiveProps() {
    this.prepareAccordionData();
  }

  shouldComponentUpdate(nextProps) {
    return !(
      nextProps.isMenuOpen === this.props.isMenuOpen &&
      nextProps.id === this.props.id
    );
  }

  onMenuToggle() {
    this.props.dispatch(toggleMenu());
  }

  onTabClick(tabId) {
    this.props.dispatch(toggleTab(tabId));
  }

  // bringing menuGroups and products into structure that's renderable by accordion component
  prepareAccordionData() {
    let menuGroup = {};
    this.props.menuGroups.map((group, i) => {
      menuGroup = group;
      menuGroup.items = [];
      menuGroup.isOpen = 0;
      this.props.products.filter((product) => product.menuGroupId === menuGroup.id)
        .map((item) => {
          menuGroup.isOpen = menuGroup.isOpen || this.isChecked(item.id);
          if (menuGroup.isOpen) {
            this.setState({ accordionOpenIndex: i });
          }
          menuGroup.items.push(item);
          return true;
        });
      return menuGroup;
    });
  }

  isChecked(id) {
    let checked = (this.props.urlParams.productId).toString().toLowerCase() === (id).toString().toLowerCase();

    if (Object.prototype.toString.call(this.props.urlParams.productId) === '[object Array]') {
      checked = this.props.urlParams.productId.length ? this.props.urlParams.productId.indexOf(id) > -1 : this.props.defaultBasemapId === id;
    }

    const activeProduct = this.props.products.filter((product) => product.id === this.props.urlParams.productId)[0];
    checked = activeProduct && activeProduct.menuAlsoActiveWhenId && activeProduct.menuAlsoActiveWhenId.indexOf(id) > -1 ? true : checked;

    return checked;
  }

  render() {
    return (
      <div>
        {this.props.isMenuOpen ?
          <div>
            <div onClick={this.onMenuToggle} className="mt-menu-closelayer"></div>
            <div className="mt-menu desk-one-third lap-four-ninths palm-one-whole">
              <div className="mt-menu-bar">
                <div className="mt-menu-title float--left delta palm-gamma left">Karte auswählen</div>
                <div className="icon-close cursor--pointer mt-fake-fullscreen-close-button" onClick={this.onMenuToggle} title="Schließen" />
                <div className="clearfix"></div>
              </div>
              <Accordion transitionTime={100} startPosition={this.state.accordionOpenIndex}>
                {
                  this.props.menuGroups.map(group =>
                    <div key={group.label} data-trigger={group.label}>
                      {group.items.filter(item => !item.menuVisibleOnlyWhenCountryIs || (item.menuVisibleOnlyWhenCountryIs && item.menuVisibleOnlyWhenCountryIs.indexOf(window.maptoolConfig.country) > -1))
                      .map(item =>
                        <MenuTabItem
                          checked={this.isChecked(item.id)}
                          paramType={'productId'}
                          paramValue={item.id}
                          label={item.label || item.title}
                          description={item.description}
                          key={item.id}
                          inputType={'radio'}
                          imgSrc={item.imgSrc}
                          dispatch={this.props.dispatch}
                        />
                      )}
                    </div>
                  )
                }
              </Accordion>
            </div>
          </div>
        : null}
      </div>
    );
  }
}

Menu.propTypes = {
  appState: PropTypes.object,
  appActions: PropTypes.object,
};

export default Menu;



/** WEBPACK FOOTER **
 ** ./apps/maptool/components/Menu/index.js
 **/